// Cookie consent storage for gating analytics/ad scripts (GA4, Meta Pixel)
import { useEffect, useState } from 'react';

const CONSENT_KEY = 'clarity_cookie_consent';
const CONSENT_EVENT = 'clarity-consent-change';

export const getStoredConsent = () => {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(CONSENT_KEY);
};

export const setStoredConsent = (value) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(CONSENT_KEY, value);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
};

// Returns null (no choice made yet), 'granted', or 'denied'
export const useConsent = () => {
  const [consent, setConsent] = useState(getStoredConsent);

  useEffect(() => {
    const handleChange = (event) => setConsent(event.detail);
    window.addEventListener(CONSENT_EVENT, handleChange);
    return () => window.removeEventListener(CONSENT_EVENT, handleChange);
  }, []);

  return consent;
};
